import HousingPrivileges from '@/reactPages/HousingPrivileges/HousingPrivileges';
import NextWrapper from '@/components/layouts/Containers/NextWrapper/NextWrapper';

export const meta = {
  title: 'Жилье по льготной стоимости',
  description: 'Порядок предоставления арендного жилья по льготной стоимости.',
};

const Page = () => {
  return (
    <>
      <NextWrapper meta={meta}></NextWrapper>
      <HousingPrivileges></HousingPrivileges>
    </>
  );
};

export default Page;
